import React from 'react'
import { MenuItem, FormControl, Select } from '@mui/material'

const OptionType = ({ name, optionView, options, value, onChange, type }) => {
  if (options?.length && typeof options[0] == 'string') {
    options = options.map((item) => ({ label: item }))
  }
  return (
    <FormControl fullWidth>
      {optionView == 'dropdown-view' ? (
        <div className="item-center mb-3">
          <Select
            labelId="input-select-menu"
            id="input-select-menu"
            fullWidth
            label={name}
            classes={{
              select: 'flex gap-3 items-center',
            }}
            className="relative" // Ensure the Select is positioned relatively
            onChange={(e) => (type === 'multioption' ? onChange(e.target.value.join(',')) : onChange(e.target.value))}
            defaultValue={value || '3D'}
            value={type === 'multioption' ? (value ? value.split(',') : []) : value || '3D'}
            multiple={type === 'multioption' ? true : false}
          >
            <div
              id="hover-preview"
              className="absolute hidden justify-center items-center h-[240px] w-[240px] bg-white shadow-lg border border-gray-300 z-50 right-[10px] top-1/2 -translate-y-1/2 pointer-events-none"
            >
              <img id="hover-image" src="" alt="preview" className="h-full w-full object-contain" />
            </div>

            {options?.map((item, i) => (
              <MenuItem
                key={`s-${i}`}
                value={item.label}
                className="gap-3 group"
                onMouseEnter={() => {
                  if (item.image) {
                    const previewContainer = document.getElementById('hover-preview')
                    const previewImage = document.getElementById('hover-image')
                    if (previewContainer && previewImage) {
                      previewImage.src = item.image || ''
                      previewContainer.classList.remove('hidden')
                      previewContainer.classList.add('flex')
                    }
                  }
                }}
                onMouseLeave={() => {
                  if (item.image) {
                    const previewContainer = document.getElementById('hover-preview')
                    if (previewContainer) {
                      previewContainer.classList.remove('flex')
                      previewContainer.classList.add('hidden')
                    }
                  }
                }}
              >
                {/* Thumbnail */}
                {item.image && <img src={item.image} alt="ex" className="h-[80px]" />}
                {item.label}
              </MenuItem>
            ))}
          </Select>
        </div>
      ) : (
        <div
          className={`${options?.length > 3 ? 'grid' : 'flex'} gap-[6px] pb-3 overflow-x-auto`}
          style={{
            gridTemplateRows: 'repeat(2, 1fr)', // Exactly 2 rows
            gridTemplateColumns: `repeat(${Math.ceil(options?.length / 2)}, minmax(195px, 1fr))`, // Dynamic columns based on items
          }}
        >
          {options?.map((item, i) => (
            <div
              key={`radio-${i}`}
              onClick={() => onChange(item.label)}
              className={`h-[150px] min-w-[195px] max-w-[210px] flex flex-col items-center justify-center relative cursor-pointer text-xs md:text-base capitalize text-[#797979] gap-1 ${
                value == item.label ? 'border-black border rounded-lg' : ''
              }`}
            >
              {value == item.label && (
                <img
                  src={'/assets/common/radio-checked.svg'}
                  alt="radio-checked"
                  className={`w-5 h-5 absolute top-3 right-3 ${!item.image ? 'invert' : ''}`}
                />
              )}
              <img
                src={`${item.image ? item.image : '/assets/common/uploadimg.svg'}`}
                alt="upload"
                className={`${item.image ? 'w-full rounded-lg h-[calc(100%-25px)]' : 'h-[calc(50%)]'}`}
              />
              <span
                className={
                  'h-[20px] w-full text-center break-words break-all text-black text-sm whitespace-nowrap overflow-hidden overflow-ellipsis'
                }
                title={item.label}
              >
                {item.label}
              </span>
            </div>
          ))}
        </div>
      )}
    </FormControl>
  )
}

export default OptionType
